/**
 * Estados de una cita: etiqueta + punto de color + pastilla.
 *
 * Se usa tinte suave + hairline interior (no bloque saturado) y un punto de
 * color: el estado se distingue de un vistazo incluso en modo oscuro, donde
 * las pastillas planas de un solo tono se ven sucias.
 */
export const ESTADOS = {
  citado:     { label: 'Citado',     punto: 'bg-violet-500',  pill: 'bg-violet-500/10 text-violet-700 dark:text-violet-300 ring-violet-500/25' },
  confirmada: { label: 'Confirmada', punto: 'bg-blue-500',    pill: 'bg-blue-500/10 text-blue-700 dark:text-blue-300 ring-blue-500/25' },
  en_sala:    { label: 'En sala',    punto: 'bg-amber-500',   pill: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 ring-amber-500/30' },
  atendido:   { label: 'Atendido',   punto: 'bg-emerald-500', pill: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 ring-emerald-500/25' },
  cancelada:  { label: 'Cancelada',  punto: 'bg-rose-500',    pill: 'bg-rose-500/10 text-rose-700 dark:text-rose-300 ring-rose-500/25' },
  no_asistio: { label: 'No asistió', punto: 'bg-slate-400',   pill: 'bg-slate-500/10 text-slate-600 dark:text-slate-300 ring-slate-500/25' },
};

export const estadoDe = (estado) => ESTADOS[estado] || ESTADOS.confirmada;

/** Estados que ya no ocupan lugar en la agenda de trabajo. */
export const ESTADOS_CERRADOS = ['atendido', 'cancelada', 'no_asistio'];
